import { Center, Title, Text, Stack } from '@mantine/core';

export const NotFoundPage = () => {
  return (
    <Center h="100vh">
      <Stack align="center" gap="lg">
        <Title order={1} c="dimmed" fw={700} style={{ fontSize: '6rem', lineHeight: 1 }}>
          404
        </Title>
        <Title order={2}>Pagina non trovata</Title>
        <Text c="dimmed" ta="center" maw={400}>
          L&apos;URL deve contenere un form GUID valido.
        </Text>
      </Stack>
    </Center>
  );
};
